import {Component, Inject, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    template: '<div class="h-100"><ng-container *ngTemplateOutlet="template"/></div>',
    standalone: false
})
export class SidebarDialogContentHostComponent {
    template: TemplateRef<any>;

    constructor(
        @Inject(MAT_DIALOG_DATA) dialogData: SidebarDialogData,
    ) {
        this.template = dialogData.template;
    }
}

export interface SidebarDialogData {
    template: TemplateRef<any>;
}
